import { trpc } from '@/shared/api/trpc';

const POLL_MS = 60_000;

/** Customer / agent comments still awaiting the signed-in consultant (XT-902). */
export const usePendingCommentCount = (enabled: boolean) =>
  trpc.customerPreviewDiscussion.pendingCommentCount.useQuery(undefined, {
    enabled,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
    retry: false,
  });
